export enum GPSMode {
  Relative = 'relative',
  Absolute = 'absolute',
}

export enum GPSForm {
  Circle = 'circle',
  Polygon = 'polygon',
}

export interface Polygon {
  coords: number[][]
}

export interface GPSLocation {
  showLocation?: boolean
  label: string
  showLabel?: boolean
  mode: GPSMode
  // 1 - GPS Mode => Relative
  distance?: number
  useDirection?: boolean
  minAngle?: number
  maxAngle?: number
  // 2 - GPS mode => Absolute
  form?: GPSForm
  // 2.1 - GPS form => Circle
  radius?: number
  long?: number
  lat?: number
  // 2.2 - GPS form => Polygon
  polygons?: Polygon[]
}
